import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import Model, { helper, Providers } from "@tripian/model";
import { providers } from "@tripian/core";
import { saveNotification } from "../redux/action/user";
import moment from "moment";

const initialCatalog: Providers.Viator.CatalogGroup[] = [
  { title: "Adventure", items: [], parentTagIds: [22046] },
  {
    title: "Food",
    items: [],
    parentTagIds: [
      21482, 12208, 12694, 12713, 13285, 13288, 16548, 20245, 21482, 21567,
      21911,
    ],
  },
  {
    title: "Culture History",
    items: [],
    parentTagIds: [21479, 21511, 21517, 21910],
  },
  {
    title: "Sightseeing",
    items: [],
    parentTagIds: [11926, 11941, 12989, 20241, 21725, 21729, 21913],
  },
  {
    title: "Art Museum",
    items: [],
    parentTagIds: [10847, 12716, 13109, 21514],
  },
  {
    title: "Local Neighborhood",
    items: [],
    parentTagIds: [11265, 12208, 21754],
  },
  { title: "Others", items: [], parentTagIds: [] },
];

const useViatorCatalog = (
  cityName?: string,
  arrivalDatetime?: string,
  departureDatetime?: string
) => {
  const isViatorActive =
    typeof window !== "undefined" &&
    window.tconfig &&
    Array.isArray(window.tconfig.TOUR_TICKET_PROVIDER_IDS)
      ? window.tconfig.TOUR_TICKET_PROVIDER_IDS.includes(
          Model.PROVIDER_ID.VIATOR
        )
      : false;
  const [viatorProducts, setViatorProducts] = useState<
    Providers.Viator.Product[]
  >([]);
  const [viatorToursCatalog, setViatorToursCatalog] = useState(initialCatalog);
  const [loadingViatorTourCatalog, setLoadingViatorTourCatalog] =
    useState<boolean>(isViatorActive);
  const viatorConfig = window.tconfig.PROVIDERS.tourAndTicket.find(
    x => x.id === Model.PROVIDER_ID.VIATOR
  );
  const dispatch = useDispatch();

  useEffect(() => {
    if (Array.isArray(viatorProducts) && viatorProducts.length > 0) {
      setLoadingViatorTourCatalog(true);
      const newCatalog: Providers.Viator.CatalogGroup[] =
        helper.deepCopy(initialCatalog);

      viatorProducts.forEach(p => {
        let categorized = false;
        for (
          let catalogElement = 0;
          catalogElement < newCatalog.length;
          catalogElement++
        ) {
          if (
            p.tags.some(tag =>
              newCatalog[catalogElement].parentTagIds.includes(tag)
            )
          ) {
            newCatalog[catalogElement].items.push(p);
            categorized = true;
            break;
          }
        }
        if (!categorized) newCatalog[newCatalog.length - 1].items.push(p);
      });

      setViatorToursCatalog(newCatalog);
    } else {
      setViatorToursCatalog(initialCatalog);
    }
    setLoadingViatorTourCatalog(false);
  }, [viatorProducts]);

  useEffect(() => {
    if (
      window.tconfig.TOUR_TICKET_PROVIDER_IDS.includes(
        Model.PROVIDER_ID.VIATOR
      ) &&
      providers.viator &&
      cityName &&
      arrivalDatetime &&
      departureDatetime &&
      window.tconfig.SHOW_TOURS_AND_TICKETS
    ) {
      setLoadingViatorTourCatalog(true);

      const today = moment().startOf("day");
      const tomorrow = moment(today).add(1, "days");

      const updatedArrivalDatetime = moment(arrivalDatetime).isBefore(today)
        ? today.format("YYYY-MM-DD")
        : moment(arrivalDatetime).format("YYYY-MM-DD");
      const updatedDepartureDatetime = moment(departureDatetime).isBefore(today)
        ? tomorrow.format("YYYY-MM-DD")
        : moment(departureDatetime).format("YYYY-MM-DD");

      let cityNameDefault = cityName;
      if (cityName === "Florianópolis") {
        cityNameDefault = cityName
          .normalize("NFD")
          .replace(/[\u0300-\u036f]/g, "");
      }
      if (cityName === "Los Angeles") {
        cityNameDefault = "Los-Angeles";
      }
      if (cityName === "San Francisco")
      {
          cityNameDefault = "San Francisco California";
      }
      if (cityName === "North York")
      {
          cityNameDefault = "Toronto";
      }
      providers.viator
        .products(
          cityNameDefault,
          updatedArrivalDatetime,
          updatedDepartureDatetime,
          window.tconfig.LANDING_PAGE === "ValaiLanding" ? "DEFAULT" : undefined,
          window.tconfig.LANDING_PAGE === "ValaiLanding" ? "DESCENDING" : undefined,
          viatorConfig?.limit
        )
        .then((response: any) => {
          if (Array.isArray(response)) {
            setViatorProducts(response);
          }
        })
        .catch(viatorFetchToursError => {
          console.error("Viator Fetch Tours Error:", viatorFetchToursError);
          dispatch(
            saveNotification(
              Model.NOTIFICATION_TYPE.ERROR,
              "ViatorFetchToursError",
              viatorFetchToursError?.message || "Unknown error"
            )
          );

          setViatorProducts([]);
          setViatorToursCatalog(initialCatalog);
        })
        .finally(() => setLoadingViatorTourCatalog(false));
    }
  }, [
    arrivalDatetime,
    cityName,
    departureDatetime,
    dispatch,
    viatorConfig?.limit,
  ]);

  return {
    viatorToursCatalog,
    loadingViatorTourCatalog,
  };
};

export default useViatorCatalog;
